// removed by extract-text-webpack-plugin
module.exports = {"column":"split__column_1dKAU","one-thirds":"split__one-thirds_K2o7Y","oneThirds":"split__one-thirds_K2o7Y","two-thirds":"split__two-thirds_PQF9C","twoThirds":"split__two-thirds_PQF9C","three-fourths":"split__three-fourths_2Mbp2","threeFourths":"split__three-fourths_2Mbp2","one-fourths":"split__one-fourths_3P5wh","oneFourths":"split__one-fourths_3P5wh"};


//////////////////
// WEBPACK FOOTER
// ./src/client/components/split/styles.less
// module id = ./src/client/components/split/styles.less
// module chunks = comics